import { z } from 'zod';
/**
 * A quality verdict produced by the model. UNSURE is the model's escape hatch:
 * when the score falls inside the product's uncertainty band around the
 * threshold, it declines to guess and defers to a human instead.
 */
export const VerdictSchema = z.enum(['GOOD', 'BAD', 'UNSURE']);
/** Strict pass/fail, for places that must not carry UNSURE. */
export const StrictVerdictSchema = z.enum(['GOOD', 'BAD']);
/**
 * A human annotation label. Wider than a model verdict: an operator may mark an
 * image UNSURE (needs review) rather than being forced into GOOD/BAD.
 */
export const AnnotationLabelSchema = z.enum(['GOOD', 'BAD', 'UNSURE']);
/**
 * What a named defect type implies about the product. Lets the vocabulary guide
 * the operator: choosing "hairline scratch" can imply BAD, "cosmetic mark" GOOD,
 * and "possible contamination" UNSURE.
 */
export const DefectClassificationSchema = AnnotationLabelSchema;
/** Operator roles. OPERATOR can inspect + annotate; ADMIN can also manage config. */
/**
 * OPERATOR inspects and annotates; ADMIN also configures.
 *
 * CUSTOMER is not a smaller staff role — it is somebody outside the building
 * who sees only their own line, through /api/portal/* and nothing else. See the
 * allowlist in routes/auth.ts.
 */
export const RoleSchema = z.enum(['OPERATOR', 'ADMIN', 'CUSTOMER']);
/** Device the inference model is running on. */
export const DeviceSchema = z.enum(['cuda', 'cpu']);
/** Which inference backend implementation is active. */
export const ModelBackendSchema = z.enum(['stub', 'onnx']);
//# sourceMappingURL=verdicts.js.map